import Vue from 'vue'
import VueStorage from 'vue-ls'
import config from '@/config/defaultSettings'

// base library
import Antd, { Modal,message } from 'ant-design-vue'
import VueCropper from 'vue-cropper'
import './antd-theme.less'
import './my-antd.css'
import PageLoading from '@/components/PageLoading'
import PtConfirm from '@/components/confirmModal'
// ext library
import PermissionHelper from '@/utils/helper/permission'
// import '@/components/use'
import './directives/action'

import   '@/core/directives/stickey-table-header'

// VueClipboard.config.autoSetContainer = true
message.config(
  {
    top: `60px`,
    duration: 2,
    maxCount: 2,
  }
)
Vue.prototype.$ptConfirm = PtConfirm
Vue.use(Antd)
Vue.use(PageLoading)
Vue.use(VueStorage, config.storageOptions)
Vue.use(PermissionHelper)
Vue.use(VueCropper)
